import { Affiliate, User } from "@/types";
import { ResourceName } from "@/utils";
import { Link, Typography } from "@mui/material";
import { FC } from "react";
import { Datagrid, FunctionField, List, Pagination } from "react-admin";
import { ReferralHitsCell } from "../referral-hits-cell";
import { TopToolbar } from "../top-toolbar";
import { UserNameCell } from "../user-name-cell";

const AffiliateUsersList: FC = () => {
  return (
    <List<User>
      perPage={30}
      actions={<TopToolbar />}
      pagination={<Pagination rowsPerPageOptions={[10, 15, 30, 50]} />}
      sort={{ field: "createdAt", order: "ASC" }}
      empty={<TopToolbar />} // needn't empty list component
    >
      <Datagrid
        rowClick={"show"}
        bulkActionButtons={false}
        style={{ tableLayout: "fixed" }}
      >
        <UserNameCell
          label="Name"
          source="id"
          sortBy="firstName"
          resourceName={ResourceName.AFFILIATE_USERS}
          sortable={false}
        />
        <FunctionField<Affiliate>
          sortable={false}
          label="Email"
          render={({ email }) => (
            <Typography variant="body2" noWrap>
              {email}
            </Typography>
          )}
        />
        <FunctionField<Affiliate>
          sortable={false}
          label="Web or social"
          render={({ socialUrl }) => (
            <Link href={socialUrl} target="_blank">
              Link
            </Link>
          )}
        />
        <ReferralHitsCell
          label="Referral hits"
          source=""
          resourceName={ResourceName.AFFILIATE_USERS}
          sortable={false}
        />
        <FunctionField<Affiliate>
          sortable={true}
          label="Earnings"
          source="earnings"
          render={({ earnings }) => `$${earnings / 100}`}
        />
      </Datagrid>
    </List>
  );
};

export { AffiliateUsersList };
